import {useSearchParams} from 'react-router-dom';

export const useSearchParamsHelper = () => {
  const [searchParams] = useSearchParams();
  const searchParamsObj = {};
  for (let param of searchParams.entries()) searchParamsObj[param[0]] = param[1];

  const addParams = (newParams) =>
    new URLSearchParams({
      ...searchParamsObj,
      ...newParams,
    });

  const removeParam = (param) => {
    const { [param]: p, ...rest } = searchParamsObj;
    return new URLSearchParams(rest);
  };

  return {
    addParams,
    removeParam,
  };
};
